module.exports = __webpack_public_path__ + "img/pinpai_01.16257a33.png";